<template>
  <div class="service detail wrap">
    <!-- 배경 흐르는 텍스트 -->
    <div class="text-bg ai-data">
      <div class="text-wrap">
        <p>{{ $t('service.detail.aiData.lineText.01') }}</p>
        <p>{{ $t('service.detail.aiData.lineText.02') }}</p>
        <p>{{ $t('service.detail.aiData.lineText.03') }}</p>
      </div>
    </div>

    <!-- 타이틀 섹션 -->
    <HalfPageLayout class="ai-data title">
      <template #half-left>
        <div class="img ai-data"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('service.title.aiData') }}
            </h3>
            <h6>Generative AI &amp; Data Service</h6>
            <h4>{{ $t('service.detail.aiData.subTitle') }}</h4>
          </div>
          <h5>{{ $t('service.detail.aiData.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 생성형 AI 주요 활용 영역 -->
    <HalfPageLayout class="ai-data summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.aiData.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:pencil-line-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:article-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:magnifying-glass-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>

    <!-- TDG · Zenith 협업 서비스 -->
    <HalfPageLayout class="ai-data summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('service.detail.aiData.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:binoculars-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:robot-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:arrows-clockwise-thin" />
              <dl>
                <dt>{{ $t('service.detail.aiData.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('service.detail.aiData.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 도입 기대 효과 -->
    <section class="section ai-data benefit bg-light">
      <h2 class="hl section-title" data-aos="fade">
        {{ $t('service.detail.aiData.benefit.title') }}
      </h2>
      <div class="section-contents">
        <div
          class="benefit-grid inner-contents"
          data-aos="fade"
          data-aos-delay="200"
        >
          <dl
            v-for="(item, key) in $tm('service.detail.aiData.benefit.contents')"
            :key="key"
            class="benefit-card"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </dl>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ServiceDetailAiData',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
